import { render, staticRenderFns } from "./contact-sales.vue?vue&type=template&id=ed4f2490&"
import script from "./contact-sales.vue?vue&type=script&lang=js&"
export * from "./contact-sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContactSalesForm: require('/opt/build/repo/components/forms/ContactSalesForm.vue').default})
